// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gyarados_mega: PokeData = {
  "id": 10041,
  "name": "gyarados-mega",
  "height": 65,
  "weight": 3050,
  "base_experience": 224,
  "types": [
    PokeType.WATER,
    PokeType.DARK
  ],
  "api_moves": [
    "bind",
    "thrash",
    "leer",
    "bite",
    "hydro-pump",
    "hyper-beam",
    "dragon-rage",
    "rage",
    "waterfall",
    "scary-face",
    "outrage",
    "twister",
    "rain-dance",
    "crunch",
    "dragon-dance",
    "aqua-tail",
    "ice-fang",
    "dragon-tail",
    "hurricane"
  ],
  "moves": [
    "leer",
    "bite",
    "hydro-pump",
    "scary-face",
    "outrage",
    "rain-dance",
    "crunch",
    "dragon-dance",
    "aqua-tail",
    "ice-fang",
    "hurricane",
    "bubble-beam",
    "dark-pulse"
  ],
  "evolution_chain": {
    "id": 64,
    "item": null,
    "species": [
      {
        "name": "magikarp",
        "order": 153,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gyarados",
        "order": 154,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 129,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 125,
    "speed": 94,
    "ability_power": 181
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
